import * as React from 'react';

import { canUseDOM } from '../../lib';
import { classHrComponentsVersion } from './hrComponentsVersion';

type UseHrComponentsVersionParams = {
    targetContainer: null | undefined | Element;
};

/**
 * Устанавливает класс `HR-<version>` на нужный элемент
 */
function useHrComponentsVersion({
    targetContainer = canUseDOM() ? document.body : null,
}: UseHrComponentsVersionParams) {
    React.useLayoutEffect(() => {
        if (!canUseDOM() || !targetContainer) return;
        targetContainer.classList.add(classHrComponentsVersion);
        return () => {
            targetContainer.classList.remove(classHrComponentsVersion);
        };
    }, [targetContainer]);
}

export type { UseHrComponentsVersionParams };
export { useHrComponentsVersion };
